import { render, staticRenderFns } from "./WhatsNew.vue?vue&type=template&id=4a5d70f6"
import script from "./WhatsNew.vue?vue&type=script&lang=ts"
export * from "./WhatsNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports